import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { SnapAndSellAdPageComponent } from './components/page/snap-and-sell-ad-page.component';
import { SnapAndSellAdRoutingModule } from './snap-and-sell-ad-routing.module';
import { MatButtonModule } from '@angular/material/button';
import { Angulartics2Module } from 'angulartics2';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [
    SnapAndSellAdPageComponent
  ],
  imports: [
    CommonModule,
    SnapAndSellAdRoutingModule,
    Angulartics2Module,
    MatButtonModule,
    SharedModule,
    NgOptimizedImage
  ],
})
export class SnapAndSellAdModule { }
